import { TableRow } from '@hulu/react-style-components';
import upperFirst from 'lodash/upperFirst';
import React from 'react';
import { HeaderGroup } from 'react-table';

import HeaderSortPart from '../HeaderSortPart/HeaderSortPart';
import { StyledHeaderCell, StyledTableCell, StyledTableHeader } from './styled';

type Props<T extends object> = {
  headerCellTestId: string;
  headerGroups: HeaderGroup<T>[];
  handleSorting?: (column: HeaderGroup<T>) => void;
  className?: string;
};

const Header = <T extends object>({
  headerCellTestId,
  headerGroups,
  handleSorting,
  className,
}: Props<T>): JSX.Element => {
  return (
    <StyledTableHeader className={className}>
      {headerGroups.map((headerGroup) => (
        <TableRow {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => {
            const sortToggleProps = column.getSortByToggleProps ? column.getSortByToggleProps() : {};
            const handleSortClick = (e: React.MouseEvent<Element, MouseEvent>): void => {
              if (!handleSorting || !sortToggleProps?.onClick) return;
              sortToggleProps.onClick(e);
              handleSorting(column);
            };

            return (
              <StyledTableCell
                {...column.getHeaderProps()}
                key={column.id}
                $left={column.stickyLeft}
                $minWidth={column.minWidth}
                className={`${column.tableBorders?.subHeaders?.left ? 'leftBorder' : ''} ${
                  column.tableBorders?.subHeaders?.right ? 'rightBorder' : ''
                } ${column.sticky ? 'sticky' : ''}`}
              >
                <StyledHeaderCell data-testid={`${headerCellTestId}${upperFirst(column.id)}`}>
                  {column.render('Header')}
                  {column.canFilter && column.render('Filter')}
                  <div data-testid={`sortElement_${column.id}`} {...sortToggleProps} onClick={handleSortClick}>
                    <HeaderSortPart
                      isSorted={column.isSorted}
                      isSortedDesc={column.isSortedDesc}
                      canSort={column.canSort}
                    />
                  </div>
                </StyledHeaderCell>
              </StyledTableCell>
            );
          })}
        </TableRow>
      ))}
    </StyledTableHeader>
  );
};

export default Header;
